(function() {
    'use strict';
    var ProceduresBaseCtrl = function (autoInit) {
        return function (_, $scope, $stateParams, MyChartService, PatientPortalStorageRepository) {
            $scope.name = 'Procedures';
            $scope.loading = false;

            var activePatient = PatientPortalStorageRepository.getActivePatient();
            var loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };

            $scope.hidden = function hidden(proc) {
                if (proc.Notes || proc.Long) {
                    proc.Show = !proc.Show;
                }
            };

            function initialize() {
                $scope.loading = true;
                $scope.removeHttpError();
                MyChartService
                    .getProcedures(activePatient.id)
                    .then(function (data) {
                        $scope.procedures = _.map(data, function (element, index) {
                            return _.assignIn(element, {
                                Id: index, // since the getProcedures call does not return a uniquely identifying property ...
                                Show: false,
                                //todo: find different solution than hard coding 55 as the length of the description
                                Long: element.Description ? element.Description.length > 55 : false
                                });
                        });
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
                auditProcedures(reportRequestDto);
            }

            function auditProcedures(reportRequestDto) {
                MyChartService.auditProceduresLogging(reportRequestDto);
            }

            $scope.tileState = {
                isCollapsed: undefined                
            };
            $scope.toggleState = function() {
                if($scope.tileState.isCollapsed === undefined)
                {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            };

            $scope.auditProcedures = auditProcedures;

            if(autoInit) {
                initialize();  
            }
        };
    };

    var ProceduresCtrl = new ProceduresBaseCtrl(true);
    var ProceduresMobileCtrl = function (_, $scope, $stateParams, MyChartService, PatientPortalStorageRepository, $modal) {
        new ProceduresBaseCtrl(false).call(this, _, $scope, $stateParams, MyChartService, PatientPortalStorageRepository);
        $scope.viewModal = function(procId) {
            var modalInstance = $modal.open({
                templateUrl: '/mychart/views/mobile/genericModal.html',
                controller: 'GenericModalCtrl',
                scope: $scope,
                resolve: {
                    canPrint: function() {
                        return false;
                    },
                    modalContent: function () {
                        var procedure = _.find($scope.procedures, { Id: procId });
                        var modalContent =
                                '<div>' + new Date(procedure.VisitDate).toLocaleDateString() + '</div>' +
                                '<div>' + procedure.Name + '</div>' +
                                '<div>' + procedure.Description + '</div>';
                        return modalContent;
                    }
                }
            });
            modalInstance.result.then(function() {
            });
        };
    };
    
    angular.module('mychart').controller('ProceduresCtrl',
        ['_', '$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository',
            ProceduresCtrl]);
    angular.module('mychart').controller('ProceduresMobileCtrl',
        ['_', '$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository', '$uibModal',
            ProceduresMobileCtrl]);
})();
